import { BoxProps } from "@material-ui/core"
import { Box, BrowseButton, Button, Field, ImageLightbox } from "components"
import { compose, withHooks } from "enhancers"
import get from "lodash/get"
import map from "lodash/map"
import range from "lodash/range"
import ImageUpload from "./ImageUpload"

interface ImageUploadListProps extends BoxProps {
  amount: number
  name: string
  label: any
  canAddMore: boolean
  addButtonLabel: string
  openImageLightbox: (idx: number) => void
  removeImage: (idx: number) => void
  addImage: () => void
}
const ImageUploadList = (props: ImageUploadListProps) => (
  <Box {...props}>
    <Box display="flex">
      {range(props.amount).map((index) => {
        return (
          <Box key={index} mt={6} mr={6}>
            <Box onClick={() => props.openImageLightbox(index)}>
              <Field component={ImageUpload} name={`${props.name}[${index}]`} />
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" mt={2.5}>
              {props.label ? props.label(index) : null}
              <Button
                startIcon="bigTrash"
                style={{ minWidth: 32, paddingLeft: 0, paddingRight: 0 }}
                onClick={() => props.removeImage(index)}
              />
            </Box>
          </Box>
        )
      })}
    </Box>
    <BrowseButton
      startIcon="add"
      onBrowse={props.addImage}
      mt={6}
      width={171}
      accept="image/*"
      disabled={!props.canAddMore}
    >
      {props.addButtonLabel}
    </BrowseButton>
  </Box>
)

const enhancer = compose(
  withHooks((props: any, hooks: any) => {
    const { form, name, insert, remove, title, addButtonLabel, mt, label, onRemoveImage, max } = props
    const { useCallback } = hooks
    const values = get(form.values, name)
    const amount = values?.length ?? 0

    const canAddMore = amount < max
    const addImage = useCallback(
      (file: any) => {
        if (canAddMore) {
          insert(amount, file)
        }
      },
      [insert, amount, canAddMore],
    )

    const removeImage = useCallback(
      (index: number) => {
        remove(index)
        if (onRemoveImage) {
          onRemoveImage(index, props)
        }
      },
      [remove, onRemoveImage, props],
    )

    const openImageLightbox = useCallback(
      (index: number) => {
        const images = map(values, (file, index) => {
          return {
            url: file instanceof File ? URL.createObjectURL(file) : null,
            title: `รูปที่ ${index + 1}`,
          }
        })
        ImageLightbox.open({
          images,
          startIndex: index,
        })
      },
      [values],
    )

    return {
      name,
      amount,
      addImage,
      removeImage,
      title,
      addButtonLabel,
      mt,
      label,
      canAddMore,
      openImageLightbox,
    }
  }),
)

export default enhancer(ImageUploadList)
